import React from 'react';
import { Prompt } from 'react-router';

interface Props {
  originalValues: any,
  currentValues: any
}

const UnsavedChangesPrompt: React.FC<Props> = ({
  originalValues,
  currentValues
}) => {
  return (
    <Prompt
      when={originalValues !== currentValues}
      message="You have unsaved edits, are you sure you want to leave?"
    />
  )
}

export default UnsavedChangesPrompt;
